/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.1",
    versionName: "0.2.0-nightly.2025.12.1",
    versionChannel: "nightly",
    buildDate: "2025-12-01T00:09:05.507Z",
    commitHash: "a0a083473633115a9569faee344cb0da4ff76d45",
};
